import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import {
  CancelButton,
  SaveButton,
} from "../../components/common/MainButtonComponent";
import "./ExamSection.css";

export default function ExamFlowConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Yes",
  cancelLabel = "Cancel",
  onConfirm,
  onClose,
  loading = false,
  disabled = false,
}) {
  if (!open) {
    return null;
  }

  const isDisabled = loading || disabled;

  return (
    <div className="exam-confirm-modal" role="dialog" aria-modal="true">
      <button
        type="button"
        className="exam-confirm-modal__backdrop"
        onClick={() => {
          if (!isDisabled) {
            if (onClose) {
              onClose();
            }
          }
        }}
        disabled={isDisabled}
        aria-label="Close confirmation"
      />

      <div className="exam-confirm-modal__card">
        <span className="exam-confirm-modal__icon" aria-hidden="true">
          <HiOutlineInformationCircle />
        </span>

        <h2>{title}</h2>

        {message ? <p>{message}</p> : null}

        <div className="exam-confirm-modal__actions">
          <SaveButton
            label={confirmLabel}
            onClick={() => {
              if (!isDisabled) {
                if (onConfirm) {
                  onConfirm();
                }
              }
            }}
            disabled={isDisabled}
          />

          <CancelButton
            label={cancelLabel}
            onClick={() => {
              if (!isDisabled) {
                if (onClose) {
                  onClose();
                }
              }
            }}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
}